module.exports = __webpack_public_path__ + "img/p1_bg.8587177e.jpg";